import { render, staticRenderFns } from "./PhoneNumberConfirmation.vue?vue&type=template&id=481b68ee&scoped=true&lang=pug&"
import script from "./PhoneNumberConfirmation.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberConfirmation.vue?vue&type=style&index=0&id=481b68ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481b68ee",
  null
  
)

export default component.exports